import { jsx as c, jsxs as o } from "react/jsx-runtime";
import { c as b } from "../clsx-OuTLNxxd.js";
import { Icon as l } from "../Icon/Icon.js";
const k = "BarCheckbox-module_container__KAMML",
  u = "BarCheckbox-module_content__h3S4P",
  x = "BarCheckbox-module_label-container__OQRry",
  p = "BarCheckbox-module_check-icon__U2ddf",
  C = "BarCheckbox-module_main-icon__vY0pp",
  B = "BarCheckbox-module_label__-XTuB",
  N = "BarCheckbox-module_label-text__EyXjG",
  g = "BarCheckbox-module_description__3iDHd",
  v = "BarCheckbox-module_counter__q-yH-",
  I = "BarCheckbox-module_input__cpn6n",
  f = "BarCheckbox-module_background-color-white__-bQOs",
  y = "BarCheckbox-module_dark-variant__VPYB6",
  e = {
    container: k,
    content: u,
    labelContainer: x,
    checkIcon: p,
    mainIcon: C,
    label: B,
    labelText: N,
    description: g,
    counter: v,
    input: I,
    backgroundColorWhite: f,
    darkVariant: y
  },
  W = _ref => {
    let {
      disabled: r,
      checked: i,
      label: s,
      counterLabel: n,
      onChange: d,
      children: _,
      description: m,
      variant: a = "gray",
      iconName: t,
      dataContentPiece: h
    } = _ref;
    return /* @__PURE__ */c("div", {
      className: b(e.container, {
        [e.backgroundColorWhite]: a == "white",
        [e.darkVariant]: a == "titanium"
      }),
      children: /* @__PURE__ */o("label", {
        className: e.labelContainer,
        children: [/* @__PURE__ */c("input", {
          className: e.input,
          type: "checkbox",
          disabled: r,
          checked: i,
          onChange: d,
          "data-content-piece": h
        }), /* @__PURE__ */o("div", {
          className: e.content,
          children: [t && /* @__PURE__ */c(l, {
            name: t,
            size: "1.5x",
            padding: !1,
            className: e.mainIcon
          }), /* @__PURE__ */o("div", {
            className: e.label,
            children: [/* @__PURE__ */c("div", {
              className: e.labelText,
              children: s
            }), /* @__PURE__ */c("div", {
              className: e.description,
              children: m
            })]
          }), n && /* @__PURE__ */c("div", {
            className: e.counter,
            children: n
          }), _, /* @__PURE__ */c(l, {
            name: "check",
            size: "1.5x",
            padding: !1,
            className: e.checkIcon
          })]
        })]
      })
    });
  };
export { W as BarCheckbox };